import botImage from 'images/nifty-orbit.png';

export const userRoles = () => {
    return [
        {
            id: 'regular',
            accessLevel: 3,
            title: 'Team Member',
            info: 'Team members can assign fellow members and create projects within their portfolios but can’t invite new members into the workspace.',
            richInfo: '**Team members** can assign fellow members and create projects within their portfolios but can’t invite new members into the workspace.',
            transferNote: 'Note: Any and all data owned by this user will be transferred to you.'
        },
        {
            id: 'manager',
            accessLevel: 2,
            title: 'Admin',
            info: 'Admins are project managers that can create and archive projects, as well as manage project members.',
            richInfo: '**Admins** are project managers that can create and archive projects, as well as manage project members.'
        },
        {
            id: 'super admin',
            accessLevel: 1,
            title: 'Super Admin',
            info: 'Super Admins can manage all projects and team members.',
            richInfo: '**Super Admins** can manage all projects and team members.',
            disabled: true
        },
        {
            id: 'owner',
            accessLevel: 0,
            title: 'Owner',
            info: 'Owner can manage all projects, team members and billing for the team account.',
            richInfo: '**Owner** can manage all projects, team members and billing for the team account.',
            disabled: true
        },
        {
            id: 'client',
            accessLevel: 4,
            title: 'Guest',
            info: 'Guests can only participate in invited projects and have a limited role.',
            richInfo: '**Guests** can only participate in invited projects and have a limited role.'
        }
    ];
};

export const docPermissions = () => {
    return [
        // {
        //     id: 'view',
        //     title: 'View'
        // },
        {
            id: 'comment',
            title: 'View & Comment'
        },
        {
            id: 'edit',
            title: 'View, Comment & Edit'
        }
    ]
}

export const teamPlans = () => {
    return [
        {
            key: 'X_Basic_Plan',
            id: 'X_Basic_Plan',
            name: 'Basic',
            price: {
                free: true,
                monthly: 0,
                annual: 0,
                perMember: true
            },
            description: 'Best for solo & small teams. Basic to help you get started.',
            features: [
                '3 Team Members',
                '2 Active Projects',
                '1 GB Space / Member',
                'Self-serve knowledge base'
            ],
            quota: {
                storageBytes: 1073741824,
                members: 3,
                clients: 0,
                projects: 2,
                fileBytes: 26214400
            },
            show: false
        },
        {
            key: 'X_Standard',
            id: 'X_Standard',
            name: 'Standard',
            price: {
                monthly: 10,
                annual: 8,
                perMember: true
            },
            description: 'Best for smaller and medium-sized teams. Simple yet powerful.',
            features: [
                'Unlimited Team Members',
                'Unlimited Projects',
                'Unlimited Guests',
                '5 GB Space / Member',
                'Standard Support'
            ],
            quota: {
                storageBytes: 5368709120
            },
            show: false
        },
        {
            key: 'X_Premium',
            id: 'X_Premium',
            name: 'Premium',
            price: {
                monthly: 15,
                annual: 12,
                perMember: true
            },
            description: 'Best for medium to large teams. Access to power features.',
            features: [
                '**Everything in Standard, plus:**',
                '15 GB Space / Member',
                'Time Tracking & Reporting',
                'Custom Fields',
                'Google SSO',
                'Priority Support'
            ],
            quota: {
                storageBytes: 16106127360
            },
            show: false
        },
        {
            key: 'X_Educational',
            id: 'X_Educational',
            name: 'Special',
            price: {
                monthly: 0,
                annual: 0,
                perMember: true
            },
            description: 'Best for smaller and medium-sized teams. Simple yet powerful.',
            features: [
                'Unlimited Team Members',
                'Unlimited Projects',
                'Unlimited Guests',
                '5 GB Space / Member',
                'Time Tracking & Reporting',
                'Custom Fields',
                'Google SSO',
                'Priority Support'
            ],
            quota: {
                storageBytes: 5368709120
            },
            show: false
        },
        {
            key: 'X_Enterprise',
            id: 'X_Enterprise',
            name: 'Enterprise',
            price: {
                monthly: 0,
                annual: 0,
                perMember: true
            },
            description: 'A fully customizable solution for the most advanced teams.',
            features: [
                '**Everything in Standard, plus:**',
                'Custom Integrations',
                'Custom Branding',
                'More Space',
                'SSO Support'
            ],
            show: false
        },
        {
            key: 'X_Starter',
            id: 'X_Starter',
            name: 'Starter',
            price: {
                monthly: 49,
                annual: 39
            },
            description: 'Best for solo & small teams. Essentials to help you get started.',
            features: [
                'Up to 10 Members',
                '10 Active Projects',
                '100 GB Space',
                'Unlimited Guests & Clients',
                'Project Portfolios',
                'Self-serve knowledge base'
            ],
            quota: {
                storageBytes: 1073741824 * 100,
                members: 10,
                projects: 10
            },
            show: true
        },
        {
            key: 'X_Pro',
            id: 'X_Pro',
            name: 'Pro',
            price: {
                monthly: 99,
                annual: 79
            },
            description: 'Best for medium to large teams. Simple yet powerful.',
            features: [
                'Up to 25 Members',
                'Unlimited Projects',
                '500 GB Space',
                '**Everything in Starter, plus:**',
                'Project Overviews',
                'Premium Support'
            ],
            quota: {
                storageBytes: 1073741824 * 500,
                members: 25
            },
            show: true
        },
        {
            key: 'X_Business',
            id: 'X_Business',
            name: 'Business',
            price: {
                monthly: 149,
                annual: 124
            },
            description: 'Best for medium to large teams. Access to power features.',
            features: [
                'Up to 50 Members',
                'Unlimited Projects',
                '1 TB Space',
                'Unlimited Guests & Clients',
                '**Everything in Pro, plus:**',
                'Time Tracking & Reporting',
                'Team Workloads',
                'Custom Fields'
            ],
            quota: {
                storageBytes: 1073741824 * 1000,
                members: 50
            },
            show: true
        },
        {
            key: 'App_Sumo_1',
            id: 'App_Sumo_1',
            name: 'AppSumo 1',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 100,
                members: 3
            },
            show: false
        },
        {
            key: 'App_Sumo_2',
            id: 'App_Sumo_2',
            name: 'AppSumo 2',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 200,
                members: 6
            },
            show: false
        },
        {
            key: 'App_Sumo_3',
            id: 'App_Sumo_3',
            name: 'AppSumo 3',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 500,
                members: 9
            },
            show: false
        },
        {
            key: 'App_Sumo_4',
            id: 'App_Sumo_4',
            name: 'AppSumo 4',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 600,
                members: 12
            },
            show: false
        },
        {
            key: 'App_Sumo_5',
            id: 'App_Sumo_5',
            name: 'AppSumo 5',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1000,
                members: 15
            },
            show: false
        },
        {
            key: 'App_Sumo_6',
            id: 'App_Sumo_6',
            name: 'AppSumo 6',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1200,
                members: 18
            },
            show: false
        },
        {
            key: 'App_Sumo_7',
            id: 'App_Sumo_7',
            name: 'AppSumo 7',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1400,
                members: 21
            },
            show: false
        },
        {
            key: 'App_Sumo_8',
            id: 'App_Sumo_8',
            name: 'AppSumo 8',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1600,
                members: 24
            },
            show: false
        },
        {
            key: 'App_Sumo_9',
            id: 'App_Sumo_9',
            name: 'AppSumo 9',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1800,
                members: 27
            },
            show: false
        },
        {
            key: 'App_Sumo_10',
            id: 'App_Sumo_10',
            name: 'AppSumo 10',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 30
            },
            show: false
        },
        {
            key: 'App_Sumo_11',
            id: 'App_Sumo_11',
            name: 'AppSumo 11',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 33
            },
            show: false
        },
        {
            key: 'App_Sumo_12',
            id: 'App_Sumo_12',
            name: 'AppSumo 12',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 36
            },
            show: false
        },
        {
            key: 'App_Sumo_13',
            id: 'App_Sumo_13',
            name: 'AppSumo 13',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 39
            },
            show: false
        },
        {
            key: 'App_Sumo_14',
            id: 'App_Sumo_14',
            name: 'AppSumo 14',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 42
            },
            show: false
        },
        {
            key: 'App_Sumo_15',
            id: 'App_Sumo_15',
            name: 'AppSumo 15',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 45
            },
            show: false
        },
        {
            key: 'App_Sumo_16',
            id: 'App_Sumo_16',
            name: 'AppSumo 16',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 48
            },
            show: false
        },
        {
            key: 'App_Sumo_17',
            id: 'App_Sumo_17',
            name: 'AppSumo 17',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 51
            },
            show: false
        },
        {
            key: 'App_Sumo_18',
            id: 'App_Sumo_18',
            name: 'AppSumo 18',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 54
            },
            show: false
        },
        {
            key: 'App_Sumo_19',
            id: 'App_Sumo_19',
            name: 'AppSumo 19',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 57
            },
            show: false
        },
        {
            key: 'App_Sumo_20',
            id: 'App_Sumo_20',
            name: 'AppSumo 20',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2000,
                members: 60
            },
            show: false
        }
    ];
}

export const FILE_GROUPS = [
    {
        id: 'all',
        title: 'All Files',
        icon: 'ion-file',
        types: []
    },
    {
        id: 'images',
        title: 'Images',
        icon: 'ion-android-image',
        types: ['jpg', 'jpeg', 'gif', 'png', 'tif', 'tiff']
    },
    {
        id: 'documents',
        title: 'Documents',
        icon: 'ion-android-document',
        types: ['doc', 'docx', 'otf', 'txt', 'pdf']
    },
    {
        id: 'presentations',
        title: 'Presentations',
        icon: 'slideshow',
        types: ['ppt', 'pptx']
    },
    {
        id: 'spreadsheets',
        title: 'Spreadsheets',
        icon: 'border_all',
        types: ['xls', 'xlsx', 'csv']
    },
    {
        id: 'video',
        title: 'Video',
        icon: 'play_arrow',
        types: ['mp4', 'webm', 'avi', 'mov']
    },
    {
        id: 'audio',
        title: 'Audio',
        icon: 'audiotrack',
        types: ['aac', 'm4a', 'mp3']
    },
    {
        id: 'code',
        title: 'Code',
        icon: 'code',
        types: ['html', 'json', 'java', 'css', 'php', 'js']
    },
    {
        id: 'designs',
        title: 'Designs',
        icon: 'brightness_high',
        types: ['ai', 'psd', 'sketch']
    },
    {
        id: 'other',
        title: 'Other',
        icon: 'more_horiz',
        types: ['tar', 'tgz', 'key', 'epub', 'rar', 'xmal', 'zip', 'ttf']
    }
];

export const BOT = {
    name: 'Nifty Orbit',
    image: botImage
};

export const COLORS = {
    '#02bdad': {
        primary: '#02bdad',
        secondary: '#00a99b',
        text: '#fff',
        selectable: true
    },
    '#feae4c': {
        primary: '#feae4c',
        secondary: '#ff8e42',
        text: '#000',
        selectable: true
    },
    '#df67ff': {
        primary: '#df67ff',
        secondary: '#c44ae4',
        text: '#fff',
        selectable: true
    },
    '#626262': {
        primary: '#626262',
        secondary: '#2f2f2f',
        text: '#fff',
        selectable: true
    },
    '#ffcc34': {
        primary: '#ffcc34',
        secondary: '#f6b800',
        text: '#000',
        selectable: true
    },
    '#ff735f': {
        primary: '#ff735f',
        secondary: '#ff5a43',
        text: '#fff',
        selectable: true
    },
    '#8dd7ff': {
        primary: '#8dd7ff',
        secondary: '#5cc0f5',
        text: '#fff',
        selectable: true
    },
    '#efefef': {
        primary: '#efefef',
        secondary: '#dfdfdf',
        text: '#000',
        selectable: true
    },
    '#20f0c5': {
        primary: '#20f0c5',
        secondary: '#03cea4',
        text: '#fff',
        selectable: true
    },
    '#9780ff': {
        primary: '#9780ff',
        secondary: '#512df6',
        text: '#fff',
        selectable: true
    },
    '#031a6b': {
        primary: '#031a6b',
        secondary: '#3752af',
        text: '#fff',
        selectable: true
    },
    '#7527d3': {
        primary: '#7527d3',
        secondary: '#5d03bd',
        text: '#fff',
        selectable: true
    },
    '#5db4ff': {
        primary: '#5db4ff',
        secondary: '#0089ff',
        text: '#fff',
        selectable: true
    },
    '#ff81be': {
        primary: '#ff81be',
        secondary: '#ff278f',
        text: '#fff',
        selectable: true
    },
    '#dd8d31': {
        primary: '#dd8d31',
        secondary: '#a75f0c',
        text: '#fff',
        selectable: true
    },
    '#f1f7fd': {
        primary: '#f1f7fd',
        secondary: '#d7e4ef',
        text: '#000',
        selectable: true
    },
    '#fff4f4': {
        primary: '#fff4f4',
        secondary: '#fededf',
        text: '#000',
        selectable: true
    },
    '#fffaee': {
        primary: '#fffaee',
        secondary: '#efe5ce',
        text: '#000',
        selectable: true
    },
    '#cecece': {
        primary: '#cecece',
        secondary: '#a2a2a2',
        text: '#000',
        selectable: true
    },
    '#ffee7e': {
        primary: '#ffee7e',
        secondary: '#ffe01a',
        text: '#000',
        selectable: true
    },
    '#ffc107': {
        primary: '#ffc107',
        secondary: '#f6b800',
        text: '#000',
        selectable: false
    },
    '#f9a33a': {
        primary: '#f9a33a',
        secondary: '#ff8e42',
        text: '#000',
        selectable: false
    },
    '#fc93ae': {
        primary: '#fc93ae',
        secondary: '#e27390',
        text: '#fff',
        selectable: false
    },
    '#2ad7d5': {
        primary: '#2ad7d5',
        secondary: '#2db5b3',
        text: '#fff',
        selectable: false
    }
};

export const DEFAULT_SIGNUP_PLAN = 'X_Business_Monthly';

export const DEFAULT_FREE_PLAN = 'X_Starter';

export const DEFAULT_THEME = 'light';

export const DEFAULT_PROJECT_ROUTE = 'home';

export const CREATE_PROJECT_ON_TEAM_CREATE = false;

export const DEFAULT_ROUTE = '/dashboard';
export const DEFAULT_LOGIN_ROUTE = '/my/tasks';
